module.exports = __webpack_public_path__ + "assets/img/icon_lesson_lyric.d7f95cf7.png";